class CartRemoveButton2 extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();

      const cartNotification = this.closest("cart-notification");
      const cartProduct = this.closest(".cart-notification-product");

      if (cartNotification) {
        cartNotification.updateQuantity(this.dataset.index, 0);
      }

      if (cartProduct) {
        cartProduct.classList.add("loading");

        if (cartProduct.firstElementChild) {
          cartProduct.firstElementChild.classList.remove("hidden");
        }
      }
    });
  }
}

if (!customElements.get("cart-remove-button-2")) {
  customElements.define("cart-remove-button-2", CartRemoveButton2);
}

class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById("offcanvas__mini_cart");
    this.cartItemConatiner = document.getElementById("cart-notification-product");

    this.emptyCartItem = document.getElementById("min-cart-items");
    this.cartItemMessageShow = document.querySelector(".empty__cart__item");
    this.emptyCartButtonDisable = document.getElementById("empty__cart__button");

    this.cartAddSuccess = document.querySelector(".item__success_message");
    this.cartEmptyHead = document.querySelector(".item__empty_message");

    this.header = document.querySelector("sticky-header");
    this.onBodyClick = this.handleBodyClick.bind(this);

    if (this.notification) {
      this.notification.addEventListener(
        "keyup",
        (evt) => evt.code === "Escape" && this.close()
      );
    }

    const closeButton = this.querySelector(
      'button[type="button"].cart-notification__close'
    );

    if (closeButton) {
      closeButton.addEventListener("click", this.close.bind(this));
    }

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce((total, quantityInput) => {
      return total + parseInt(quantityInput.value || 0);
    }, 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener("change", this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    if (!event.target.closest("select")) {
      this.updateQuantity(
        event.target.dataset.index,
        event.target.value,
        document.activeElement ? document.activeElement.getAttribute("name") : null,
        event.target.dataset.quantityVariantId
      );
    }
  }

  open() {
    if (!this.notification) return;

    this.notification.classList.add("animate", "active");

    const body = document.querySelector("body");
    if (body) {
      body.classList.add("added__overlay");
    }

    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();

        if (typeof trapFocus === "function") {
          trapFocus(this.notification);
        }
      },
      { once: true }
    );

    document.body.addEventListener("click", this.onBodyClick);
  }

  close() {
    const miniCart = document.getElementById("offcanvas__mini_cart");

    if (miniCart) {
      miniCart.classList.remove("active");
    }

    const body = document.querySelector("body");
    if (body) {
      body.classList.remove("added__overlay");
    }

    document.body.removeEventListener("click", this.onBodyClick);
  }

  renderContents(parsedState) {
    if (parsedState && parsedState.sections) {
      this.getSectionsToRender().forEach((section) => {
        const elementToReplace = document.getElementById(section.id);

        if (!elementToReplace || !parsedState.sections[section.id]) {
          return;
        }

        const newHTML = this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        );

        if (newHTML !== null) {
          elementToReplace.innerHTML = newHTML;
        }
      });
    }

    if (this.header && typeof this.header.reveal === "function") {
      this.header.reveal();
    }

    this.fetchCartAndUpdateCustomDrawer();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-notification-product",
      },
      {
        id: "cart-notification-subtotal",
      },
      {
        id: "cart-notification-count",
      },
      {
        id: "cart-notification-discount",
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement = document.getElementById(`Quantity-${line}`);
        const items = document.querySelectorAll(".cart-notification-product");

        if (parsedState.errors) {
          if (quantityElement) {
            quantityElement.value = quantityElement.getAttribute("value");
          }

          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.renderContents(parsedState);
        this.updateCustomDrawerValues(parsedState);

        const updatedValue = parsedState.items[line - 1]
          ? parsedState.items[line - 1].quantity
          : undefined;

        let message = "";

        if (
          quantityElement &&
          items.length === parsedState.items.length &&
          updatedValue !== parseInt(quantityElement.value)
        ) {
          if (typeof updatedValue === "undefined") {
            message = window.cartStrings ? window.cartStrings.error : "Error";
          } else {
            message = window.cartStrings
              ? window.cartStrings.quantityError.replace("[quantity]", updatedValue)
              : "Quantity error";
          }
        }

        this.updateLiveRegions(line, message);

        if (
          typeof publish === "function" &&
          typeof PUB_SUB_EVENTS !== "undefined"
        ) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "cart-notification",
            cartData: parsedState,
            variantId: variantId,
          });
        }
      })
      .catch((error) => {
        console.error("Cart update error:", error);
      });
  }

  fetchCartAndUpdateCustomDrawer() {
    fetch("/cart.js", {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    })
      .then((response) => response.json())
      .then((cart) => {
        this.updateCustomDrawerValues(cart);
      })
      .catch((error) => {
        console.error("Cart fetch error:", error);
      });
  }

  updateCustomDrawerValues(cart) {
    if (!cart) return;

    this.toggleCartEmptyState(cart);
    this.updateCartCount(cart);
    this.updateSubtotalAndKlarna(cart);
    this.updateFreeShippingBar(cart);
  }

  toggleCartEmptyState(cart) {
    if (!cart) return;

    const cartItemsWrapper = document.getElementById("min-cart-items");
    const emptyCartButton = document.getElementById("empty__cart__button");
    const freeShippingBar = document.querySelector(".cart-free-shipping-bar");
    const upsellWrapper = document.querySelector(".cart-upsell-wrapper");

    if (this.emptyCartItem) {
      this.emptyCartItem.classList.toggle("no-js-inline", cart.item_count === 0);
    }

    if (cart.item_count === 0) {
      if (this.emptyCartItem) this.emptyCartItem.classList.add("no-js-inline");
      if (this.emptyCartButtonDisable) this.emptyCartButtonDisable.classList.add("no-js-inline");
      if (this.cartItemMessageShow) this.cartItemMessageShow.classList.remove("no-js-inline");
      if (this.cartAddSuccess) this.cartAddSuccess.classList.add("no-js-inline");
      if (this.cartEmptyHead) this.cartEmptyHead.classList.remove("no-js-inline");

      if (cartItemsWrapper) cartItemsWrapper.classList.add("no-js-inline");
      if (emptyCartButton) emptyCartButton.classList.add("no-js-inline");
      if (freeShippingBar) freeShippingBar.classList.add("no-js-inline");
      if (upsellWrapper) upsellWrapper.classList.add("no-js-inline");
    } else {
      if (this.emptyCartItem) this.emptyCartItem.classList.remove("no-js-inline");
      if (this.emptyCartButtonDisable) this.emptyCartButtonDisable.classList.remove("no-js-inline");
      if (this.cartItemMessageShow) this.cartItemMessageShow.classList.add("no-js-inline");
      if (this.cartAddSuccess) this.cartAddSuccess.classList.remove("no-js-inline");
      if (this.cartEmptyHead) this.cartEmptyHead.classList.add("no-js-inline");

      if (cartItemsWrapper) cartItemsWrapper.classList.remove("no-js-inline");
      if (emptyCartButton) emptyCartButton.classList.remove("no-js-inline");
      if (freeShippingBar) freeShippingBar.classList.remove("no-js-inline");
      if (upsellWrapper) upsellWrapper.classList.remove("no-js-inline");
    }
  }

  updateCartCount(cart) {
    const cartCountElements = document.querySelectorAll(
      "#cart-notification-count, .cart-count-bubble span, .cart-count-bubble, [data-cart-count]"
    );

    cartCountElements.forEach((element) => {
      if (!element) return;
      element.textContent = cart.item_count;

      if (cart.item_count > 0) {
        element.classList.remove("d-none", "hidden", "no-js-inline");
      }
    });
  }

  updateSubtotalAndKlarna(cart) {
    const totalPrice = Number(cart.total_price || 0);
    const klarnaMonthlyPrice = Math.round(totalPrice / 6);

    const subtotalEl = document.getElementById("peak-cart-subtotal");
    const checkoutTotalEl = document.getElementById("cart-checkout-total");
    const klarnaMonthlyEl = document.getElementById("peak-klarna-monthly");

    if (subtotalEl) {
      subtotalEl.innerHTML = this.formatMoney(totalPrice);
    }

    if (checkoutTotalEl) {
      checkoutTotalEl.innerHTML = this.formatMoney(totalPrice);
    }

    if (klarnaMonthlyEl) {
      klarnaMonthlyEl.innerHTML = this.formatMoney(klarnaMonthlyPrice);
    }
  }

  updateFreeShippingBar(cart) {
    const freeShippingTarget = 25000;
    const totalPrice = Number(cart.total_price || 0);
    const remaining = freeShippingTarget - totalPrice;

    let percent = Math.round((totalPrice * 100) / freeShippingTarget);

    if (percent > 100) percent = 100;
    if (percent < 0) percent = 0;

    const freeShippingText = document.querySelector(".cart-free-shipping-text");
    const freeShippingProgress = document.querySelector(
      ".cart-free-shipping-progress span"
    );

    if (freeShippingText) {
      const icon = freeShippingText.querySelector(".cart-free-shipping-icon");

      if (remaining > 0) {
        freeShippingText.innerHTML =
          "You are " +
          this.formatMoney(remaining).replace(".00", "") +
          " Away from Free Shipping";
      } else {
        freeShippingText.innerHTML = "Congrats! You have Unlocked Free Shipping";
      }

      if (icon) {
        freeShippingText.appendChild(icon);
      }
    }

    if (freeShippingProgress) {
      freeShippingProgress.style.width = percent + "%";
    }
  }

  formatMoney(cents) {
    const moneyFormat =
      window.shop_money_format ||
      window.money_format ||
      "£{{amount}}";

    if (
      typeof Shopify !== "undefined" &&
      typeof Shopify.formatMoney === "function"
    ) {
      return Shopify.formatMoney(cents, moneyFormat);
    }

    const amount = (Number(cents || 0) / 100).toFixed(2);

    if (moneyFormat.includes("£")) {
      return "£" + amount;
    }

    if (moneyFormat.includes("$")) {
      return "$" + amount;
    }

    return "£" + amount;
  }

  updateLiveRegions(line, message) {
    const lineItemError = document.getElementById(`Line-item-error-${line}`);

    if (lineItemError) {
      lineItemError.classList.remove("d-none");

      const errorText = lineItemError.querySelector(".cart-item__error-text");

      if (errorText) {
        errorText.innerHTML = message;
      }
    }
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    if (!html) return null;

    const parsedHTML = new DOMParser().parseFromString(html, "text/html");
    const element = parsedHTML.querySelector(selector);

    if (!element) return null;

    return element.innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;

    if (
      this.notification &&
      target !== this.notification &&
      !target.closest("cart-notification") &&
      !target.closest("#quickViewWrapper")
    ) {
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

if (!customElements.get("cart-notification")) {
  customElements.define("cart-notification", CartNotification);
}

class OpenMiniCart extends HTMLElement {
  constructor() {
    super();

    this.cartButton = this.querySelector("a");

    if (this.cartButton) {
      this.cartButton.addEventListener("click", (event) => {
        event.preventDefault();
        this.onClickMiniCart();
      });
    }

    this.notification = document.getElementById("offcanvas__mini_cart");
    this.onBodyClassRemove = this.handleBodyClass.bind(this);

    if (this.notification) {
      this.notification.addEventListener(
        "keyup",
        (evt) => evt.code === "Escape" && this.miniCartClose()
      );
    }
  }

  onClickMiniCart() {
    const miniCart = document.getElementById("offcanvas__mini_cart");

    if (!miniCart) return;

    miniCart.classList.add("animate", "active");

    const body = document.querySelector("body");
    if (body) {
      body.classList.add("added__overlay");
    }

    this.notification = miniCart;

    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();

        if (typeof trapFocus === "function") {
          trapFocus(this.notification);
        }
      },
      { once: true }
    );

    document.body.addEventListener("click", this.onBodyClassRemove);
  }

  miniCartClose() {
    const miniCart = document.getElementById("offcanvas__mini_cart");

    if (miniCart) {
      miniCart.classList.remove("active");
    }

    const body = document.querySelector("body");
    if (body) {
      body.classList.remove("added__overlay");
    }

    document.body.removeEventListener("click", this.onBodyClassRemove);
  }

  handleBodyClass(evt) {
    const eventTarget = evt.target;

    if (
      !eventTarget.closest("cart-notification") &&
      !eventTarget.closest("open-minicart") &&
      !eventTarget.closest("button")
    ) {
      this.miniCartClose();
    }
  }
}

if (!customElements.get("open-minicart")) {
  customElements.define("open-minicart", OpenMiniCart);
}